import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import { Tooltip } from 'antd';
import { WebButton } from 'src/shared/styled';
import styled from 'styled-components';
import { BackgroundWhite, BorderGrey } from 'src/shared/color-variables';
import BookDetailModal from './BookDetailModal';
import { clickCount } from './ApiService';
import { VIEW_MODES } from './Constants';

const Wrapper = styled.div``;

const GridItemWrapper = styled.div`
  height: 380px;
  border: 1px solid ${BorderGrey};
  background-color: ${BackgroundWhite};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`;

const ListItemWrapper = styled.div`
  padding: 12px;
  border: 1px solid ${BorderGrey};
  background: ${BackgroundWhite};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
`;

const BookImg = styled.img`
  width: 135px;
  height: 190px;
`;

const ImageThumb = styled.div`
  display: block;
  box-shadow: rgb(50 50 50 / 67%) 0px 1px 5px 0px;
  border-radius: 3px;
  width: 125px;
  margin: 15px auto;
  overflow: hidden;
  height: 190px;
  float: none;
  cursor: pointer;
`;

const Content = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.div`
  display: -webkit-box;
  height: ${({ isInline }) => (isInline ? 'auto' : '40px')};
  max-height: 45px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: bold;
  font-size: 12px;
`;

const Author = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12px;
  color: #999;
  margin-bottom: 0;
`;

const BookContent = styled.div`
  font-size: 12px;
`;

const OtherInfo = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    color: var(--main-web-color);
  }
`;

function BookInfo({ book: { NumberOfFiles, NumberOfCopies, ClickCount } }) {
  return (
    <OtherInfo>
      <Tooltip title={`Có ${NumberOfFiles} file`}>
        <i className="fa-regular fa-floppy-disk mr-2" aria-hidden="true" />
        {NumberOfFiles}
      </Tooltip>
      <Tooltip title={`Có ${NumberOfCopies} bản giấy`}>
        <i className="fa fa-book mr-2" aria-hidden="true" />
        {NumberOfCopies}
      </Tooltip>
      {ClickCount ? (
        <Tooltip title={`Có ${ClickCount} lượt xem`}>
          <span>
            <i className="fa fa-eye mr-2" aria-hidden="true" />
            {ClickCount}
          </span>
        </Tooltip>
      ) : (
        ''
      )}
    </OtherInfo>
  );
}

function BookItem({ book, className, viewMode = VIEW_MODES.grid }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const viewDetail = () => {
    clickCount(book.RecordID);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Wrapper className={className}>
      {viewMode === VIEW_MODES.grid ? (
        <GridItemWrapper>
          <Tooltip title={book.Title1} mouseEnterDelay={0.5}>
            <ImageThumb onClick={viewDetail}>
              <BookImg src={book.CoverUrl} />
            </ImageThumb>
          </Tooltip>
          <Content>
            <Tooltip title={book.Title1} mouseEnterDelay={0.5}>
              <Title
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(book.Title1),
                }}
              />
            </Tooltip>
            <Author>{book.Author}</Author>
            <BookInfo book={book} />
            <WebButton type="primary" onClick={viewDetail}>
              Chi tiết
            </WebButton>
          </Content>
        </GridItemWrapper>
      ) : (
        <ListItemWrapper onClick={viewDetail}>
          <Title isInline>{book.Title1}</Title>
          <Author>{book.Author}</Author>
          {book.SearchContent ? (
            <BookContent
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(book.SearchContent),
              }}
            />
          ) : (
            ''
          )}
          <BookInfo book={book} />
        </ListItemWrapper>
      )}
      {isModalOpen && (
        <BookDetailModal
          id={book.RecordID}
          isModalOpen={isModalOpen}
          handleCancel={handleCancel}
          handleOk={handleOk}
        />
      )}
    </Wrapper>
  );
}

export default BookItem;
